module.exports = __webpack_public_path__ + "img/Grouped order Icon - white.cdf6ac55.svg";